import fetchSuggestions from './fetchSuggestions';
import mapSuggestionDataToTemplate from './mapSuggestionDataToTemplate';

const handleSuggestions = (component, $itemTemplate) => {
    const $suggestions = $(component).find('.search__suggestions');
    const $list = $(component).find('.search__suggestions__list');
    const url = $(component).attr('data-suggestions-url');
    const method = $(component).attr('data-suggestions-method');
    const param = $(component).attr('data-suggestions-query-param');

    return async (e) => {
        const query = e.target.value;
        const results = query
            ? await fetchSuggestions(url, method, { [param]: query })
            : [];

        const items = mapSuggestionDataToTemplate(results, $itemTemplate);
        $list.empty().append(items);
        $suggestions.css('visibility', items.length ? 'visible' : 'hidden');
    };
};

export default handleSuggestions;



// WEBPACK FOOTER //
// ./src/scripts/components/search/handleSuggestions.js